import $ from 'jquery';
import ThemeUtils from './ThemeUtils';

// This does not meet our current code standards, but should be replaced
// with the shopify-variants library
export default class LinkedOptions {
  constructor(options) {
    this.options = options;
    this._init();
  }

  _init() {
    this._mapVariants(this.options.productJSON);
  }

  _getCurrent(optionIndex) {
    let key;
    let selector;
    if (this.options.type === 'select') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.eq(0);
          break;

        case 1:
          key = this.options.$selector.eq(0).val();
          selector = this.options.$selector.eq(1);
          break;

        case 2:
          key = `${this.options.$selector.eq(0).val()} / ${this.options.$selector.eq(1).val()}`;
          selector = this.options.$selector.eq(2);
          break;
      }
    }

    if (this.options.type === 'radio') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector
            .filter('[data-option-index=0]')
            .filter(':checked');
          break;

        case 1:
          key = this.options.$selector
            .filter('[data-option-index=0]')
            .filter(':checked')
            .val();
          selector = this.options.$selector
            .filter('[data-option-index=1]')
            .filter(':checked');
          break;

        case 2:
          var option1 = this.options.$selector
            .filter('[data-option-index=0]')
            .filter(':checked')
            .val();
          var option2 = this.options.$selector
            .filter('[data-option-index=1]')
            .filter(':checked')
            .val();

          key = `${option1} / ${option2}`;
          selector = this.options.$selector
            .filter('[data-option-index=2]')
            .filter(':checked');
          break;
      }
    }

    return { key, selector };
  }

  _updateOptions(optionIndex, optionsMap) {
    let $selector;
    const nextSelector = optionIndex + 1;
    let updateSelected = false;

    const { key, selector } = this._getCurrent(optionIndex);

    const availableOptions = optionsMap[key] || [];

    if (this.options.type === 'select') {
      $selector = this.options.$productForm.find(selector);
      const initialValue = $selector.val();

      const $selectorOptions = $selector.find('option');

      $selectorOptions.each((index, option) => {
        const $option = $(option);

        if (availableOptions.indexOf(option.value) === -1) {
          if (option.selected) { updateSelected = true; }

          $option
            .prop('disabled', true)
            .prop('selected', false);
        } else {
          $option.prop('disabled', false);
        }
      });

      if (availableOptions.indexOf(initialValue) !== -1) {
        $selector.val(initialValue);
      }

      if (updateSelected) {
        $selectorOptions
          .filter(':not(:disabled)')
          .eq(0)
          .prop('selected', true);
      }
    }

    if (this.options.type === 'radio') {
      $selector = this.options.$selector.filter(`[data-option-index=${optionIndex}]`);

      $selector.each((index, option) => {
        const $option = $(option);

        if (availableOptions.indexOf(option.value) === -1) {
          if (option.checked) { updateSelected = true; }

          $option
            .prop('disabled', true)
            .prop('checked', false);
        } else {
          $option.prop('disabled', false);
        }
      });

      if (updateSelected) {
        $selector
          .filter(':not(:disabled)')
          .eq(0)
          .attr('checked', true)
          .trigger('click');
      }
    }

    $selector.trigger('change');
    const $nextOption = this.options.$selector.filter(`[data-option-index=${nextSelector}]`);

    if ($nextOption.length !== 0) {
      this._updateOptions(nextSelector, optionsMap);
    }
  }

  _mapVariants(product) {
    const optionsMap = [];
    optionsMap.root = [];

    product.variants.forEach((variant) => {
      if (variant.available) {
        var key;
        optionsMap.root.push(variant.option1);

        optionsMap.root = ThemeUtils.unique(optionsMap.root);

        // Gather values for the 2nd option type
        if (product.options.length > 1) {
          key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);

          optionsMap[key] = ThemeUtils.unique(optionsMap[key]);
        }

        // Gather values for the 3rd option type
        if (product.options.length > 2) {
          key = `${variant.option1} / ${variant.option2}`;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);

          optionsMap[key] = ThemeUtils.unique(optionsMap[key]);
        }
      }
    });

    this._updateOptions(0, optionsMap);

    this.options.$selector.on('change', (event) => {
      const index = parseInt($(event.currentTarget).attr('data-option-index'), 10);
      const nextSelector = index + 1;

      this._updateOptions(nextSelector, optionsMap);
    });
  }

  prepareRemove() {
    this.options.$selector.off('change');
  }
}
